<template>
  <div class="CreateCampaign">
    <el-card class="box-card" v-if="form_action != 'SUCCESS'">
      <el-steps :active="campaign_progress" finish-status="success" align-center style="width: 80%; margin: 5px auto;">
        <el-step title="Plan Promotion"></el-step>
        <el-step title="Select Communication"></el-step>
        <el-step title="Select Sales Channel"></el-step>
        <el-step title="Review & Publish"></el-step>
      </el-steps>
    </el-card>

    <el-card class="box-card mt-2" v-if="form_action != 'SUCCESS'">
      <!-- pormotion type section -->
      <div v-if="form_action == 'SELECT_PROMOTION_TYPE'">
        <div class="title">PROMOTION TYPE</div>
        <div style="margin: 20px 0 20px 0;" v-for="(promo, promo_index) in promo_type_list" :key="promo_index">
          <div style="width: 180px; margin: 0 auto;">
            <el-button
              type="text"
              class="btn text-xs"
              :class="[active_promotion == promo.title ? 'active-btn' : '']"
              @click="selectPromotion(promo)"
              >
              {{ promo.title }}
            </el-button>
          </div>

        </div>

        <div class="actio-btn-section mt-2" v-if="active_promotion">
          <BaseButton
            type="text"
            class="w-24 mr-4"
            buttonclass="btn p-2 text-xs"
            @click="cancelSelectedPromotion()"
            >
            Cancel
          </BaseButton>
          <BaseButton
            type="text"
            class="w-24"
            buttonclass="btn p-2 text-xs"
            @click="openCreateCampaignDialog('CLEAR_DISCOUNT_FORM')"
          >
          Next
          </BaseButton>
        </div>
      </div>

      <!-- communication section -->
      <div class="body" v-if="form_action == 'SELECT_COMMUNICATION_TYPE'">
        <div class="title">COMMUNICATION</div>
        <div style="margin: 20px 0 20px 0;">
          <div style="width: 180px; margin: 0 auto;">
            <el-button
              type="text"
              class="btn text-xs"
              :class="[active_communication == 'EMAIL' ? 'active-btn' : '']"
              @click="setActiveCommunication('EMAIL')"
              >
              EMAIL
            </el-button>
          </div>

          <div style="width: 180px; margin: 15px auto;">
            <el-button
              type="text"
              class="btn"
              :class="[active_communication == 'SMS' ? 'active-btn' : '']"
              @click="setActiveCommunication('SMS')"
              >
              SMS
            </el-button>
          </div>

          <div style="width: 180px; margin: 15px auto;">
            <el-button
              type="text"
              class="btn"
              >
              WHATSAPP
            </el-button>
          </div>

          <div style="width: 180px; margin: 15px auto;">
            <el-button
              type="text"
              class="btn"
              >
              FACEBOOK MESSENGER
            </el-button>
          </div>
        </div>

        <div class="footer py-4 border-t border-solid border-black">
          <div class="flex justify-end">
            <BaseButton
              type="text"
              class="w-24 mr-4"
              buttonclass="btn p-2 text-xs"
              @click="selectNextStepOfCampaign('SELECT_PROMOTION_TYPE')"
            >
              Cancel
            </BaseButton>

            <BaseButton
              type="text"
              class="w-24 mr-4"
              buttonclass="btn p-2 text-xs"
              @click="openCreateCampaignDialog()"
            >
              Back
            </BaseButton>
            <BaseButton
              type="text"
              class="w-24"
              buttonclass="btn p-2 text-xs"
              @click="goToSelectedCommunicationType()"
            >
              Next
            </BaseButton>
          </div>
        </div>
      </div>

      <!-- Email communication section -->
      <!-- <div class="body" v-if="form_action == 'EMAIL_COMMUNICATION'"> -->
      <div class="body" v-if="form_action == 'EMAIL_COMMUNICATION'">
        <div class="title">COMMUNICATION - EMAIL</div>
        <div class="divider mt-5">

          <div class="flex items-center mt-6">
            <div class="step-title" style="font-size: 11px;">Step 1</div> <div class="step-title ml-10" style="font-size: 12px;">CAMPAIGN MAIL</div>
          </div>

          <el-row :gutter="20" class="mt-5">
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <div>
                <label>Campaign Title</label>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
              <div style="line-height: 3;">
                {{ campaign_title }}
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="divider mt-5">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <div>
                <label>Select Template</label>
              </div>
            </el-col>

            <el-col :xs="16" :sm="16" :md="12" :lg="12" :xl="12">
              <el-select v-model="email_template" style="width: 100%" placeholder="Select Email Template" size="medium" filterable @change="selecteEmailTemplate(email_template)">
                <el-option v-for="(email, email_index) in email_template_list" :key="email_index" :label="email.title" :value="email_index"></el-option>
              </el-select>
            </el-col>

            <el-col :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
              <el-button type="primary active-btn" style="height: 36px; line-height: 0; font-size: 12px;" icon="el-icon-plus">CREATE NEW</el-button>
            </el-col>
          </el-row>
        </div>

        <div class="divider mt-5">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <div>
                <label>Email Title</label>
              </div>
            </el-col>
            <el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
              <el-input v-model="email_title" style="100%;" placeholder="Enter Email Title" size="medium" v-validate="'required'" name="Email title" class="email-id-input"></el-input>

              <span
                v-show="errors.has('Email title')"
                class="text-red-dark text-xs"
                >{{ errors.first("Email title") }}</span
              >
            </el-col>
          </el-row>
        </div>

        <div class="divider mt-5">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="container">
                <!-- <div id="bar" style="display: flex;">

                  <BaseButton class="w-24 mr-4" buttonclass="btn p-2 text-xs" v-on:click="saveDesign">Save Design</BaseButton>
                  <BaseButton class="w-24 mr-4" buttonclass="btn p-2 text-xs" v-on:click="exportHtml">Export HTML</BaseButton>
                </div> -->

                <EmailEditor ref="emailEditor" v-on:load="editorLoaded" />
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="divider mt-5">
          <div class="flex items-center mt-6">
            <div class="step-title" style="font-size: 11px;">Step 2</div> <div class="step-title ml-10" style="font-size: 12px;">TARGET</div>
          </div>

          <el-row :gutter="20" class="mt-5">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-radio v-model="upload_type" label="CSV">Upload Csv</el-radio>

              <input type="file" ref="file" style="display: none;" @change="getCsvFile()">
              <BaseButton
                  style="width: 100px; display: inline-block;"
                  type="text"
                  buttonclass="btn p-2 text-xs"
                  v-if="upload_type == 'CSV'"
                  @click="$refs.file.click()"
                >
                UPLOAD
              </BaseButton>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-radio v-model="upload_type" label="MANUALLY">Add Email Ids Manually</el-radio>
            </el-col>

            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" v-if="upload_type == 'MANUALLY'">
              <div v-for="(input, input_index) in email_id_input_list" :key="input_index">
                <el-input v-model="target_email_id_list[input_index]" :placeholder="'Email id ' + (input_index+1)" size="medium" class="mt-2" clearable></el-input>
              </div>

              <div class="mt-3" v-if="upload_type == 'MANUALLY'">
                <BaseButton
                  type="text"
                  class="w-24"
                  buttonclass="btn p-2 text-xs"
                  @click="addMoreEmailIdFields()"
                >
                  Add more
                </BaseButton>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="divider mt-5">
          <div class="flex items-center mt-6">
            <div class="step-title" style="font-size: 11px;">Step 3</div> <div class="step-title ml-10" style="font-size: 12px;">SCHEDULE</div>
          </div>

          <el-row :gutter="20" class="mt-5">
            <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
              <label>Schedule Mail</label>
            </el-col>

            <el-col :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
              <el-select v-model="schedule_type" style="width: 100%;" placeholder="Select schedule type" size="medium">
                <el-option label="Schedule now" value="Schedule now">Schedule Now</el-option>
                <el-option label="Schedule later" value="Schedule later">Schedule Later</el-option>
              </el-select>
            </el-col>

            <el-col :xs="8" :sm="8" :md="4" :lg="4" :xl="4" v-if="schedule_type == 'Schedule later'">
              <el-date-picker
                v-model="schedule_date"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="Schedule Date"
                size="medium"
                style="width: 100%;"
                v-validate="'required'"
                name="Schedule Date"
                clearable
              />

              <span
                v-show="errors.has('Schedule Date')"
                class="text-red-dark text-xs"
                >{{ errors.first("Schedule Date") }}</span
              >
            </el-col>

            <el-col :xs="8" :sm="8" :md="4" :lg="4" :xl="4" v-if="schedule_type == 'Schedule later'">
              <el-time-select style="width: 100%" placeholder="Schedule Time" v-model="schedule_time" size="medium" clearable v-validate="'required'" name="Schedule Time"
              :picker-options="{
                start: '00:00',
                end: '23:00'
              }"></el-time-select>

              <span
                v-show="errors.has('Schedule Time')"
                class="text-red-dark text-xs"
                >{{ errors.first("Schedule Time") }}</span
              >
            </el-col>
          </el-row>
        </div>

        <div class="footer mt-12 py-4 border-t border-solid border-black">
          <div class="flex justify-end">
            <BaseButton
              type="text"
              class="w-24 mr-4"
              buttonclass="btn p-2 text-xs"
              @click="selectNextStepOfCampaign('SELECT_PROMOTION_TYPE')"
            >
              Cancel
            </BaseButton>

            <BaseButton
              type="text"
              class="w-24 mr-4"
              buttonclass="btn p-2 text-xs"
              @click="selectNextStepOfCampaign('SELECT_COMMUNICATION_TYPE')"
            >
              Back
            </BaseButton>
            <BaseButton
              type="text"
              class="w-24"
              buttonclass="btn p-2 text-xs"
              @click="exportHtml()"
            >
              Next
            </BaseButton>
          </div>

        </div>
      </div>

      <!-- Sms communication section -->
      <!-- <div class="body" v-if="form_action == 'SMS_COMMUNICATION'"> -->
      <div class="body" v-if="form_action == 'SMS_COMMUNICATION'">
        <div class="title">COMMUNICATION - SMS</div>
        <div class="divider mt-5">

          <div class="flex items-center mt-6">
            <div class="step-title" style="font-size: 11px;">Step 1</div> <div class="step-title ml-10" style="font-size: 12px;">CAMPAIGN SMS</div>
          </div>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <div>
                <label>Campaign Title</label>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
              <div style="line-height: 3;">
                {{ campaign_title }}
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="divider mt-5">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <div>
                <label>Select Template</label>
              </div>
            </el-col>

            <el-col :xs="16" :sm="16" :md="12" :lg="12" :xl="12">
              <el-select v-model="sms_template" style="width: 100%" placeholder="Select SMS Template" size="medium" filterable @change="selectSMSTemplate(sms_template)">
                <el-option v-for="(sms,sms_index) in sms_template_list" :key="sms_index" :label="sms.title" :value="sms.template"></el-option>
              </el-select>
            </el-col>

            <el-col :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
              <el-button type="primary active-btn" style="height: 36px; line-height: 0; font-size: 12px;" icon="el-icon-plus">CREATE NEW</el-button>
            </el-col>
          </el-row>
        </div>

        <div class="divider mt-5">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <label>Message : </label>
              <el-input
                type="textarea"
                :rows="5"
                :maxlength="170"
                :show-word-limit="true"
                placeholder="Compose your message here"
                v-model="sms_content"
                v-validate="'required'" name="SMS">
              </el-input>

              <span
                v-show="errors.has('SMS')"
                class="text-red-dark text-xs"
                >{{ errors.first("SMS") }}</span
              >

            </el-col>
          </el-row>
        </div>

        <div class="divider mt-5">
          <div class="flex items-center mt-6">
            <div class="step-title" style="font-size: 11px;">Step 2</div> <div class="step-title ml-10" style="font-size: 12px;">TARGET</div>
          </div>

          <el-row :gutter="20" class="mt-5">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-radio v-model="upload_type" label="CSV">Upload Csv</el-radio>

              <input type="file" ref="file" style="display: none;" @change="getCsvFile()">
              <BaseButton
                  style="width: 100px; display: inline-block;"
                  type="text"
                  buttonclass="btn p-2 text-xs"
                  v-if="upload_type == 'CSV'"
                  @click="$refs.file.click()"
                >
                UPLOAD
              </BaseButton>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-radio v-model="upload_type" label="MANUALLY">Add Mobile Numbers Manually</el-radio>
            </el-col>

            <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" v-if="upload_type == 'MANUALLY'">
              <div v-for="(input, input_index) in mobile_no_input_list" :key="input_index">
                <el-input type="text" :maxlength="10" v-model="target_mobile_no_list[input_index]" :placeholder="'Mobile no. ' + (input_index+1)" size="medium" class="mt-2" clearable></el-input>
              </div>

              <div class="mt-3" v-if="upload_type == 'MANUALLY'">
                <BaseButton
                  type="text"
                  class="w-24"
                  buttonclass="btn p-2 text-xs"
                  @click="addMoreMobileNoFields()"
                >
                  Add more
                </BaseButton>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="divider mt-5">
          <div class="flex items-center mt-6">
            <div class="step-title" style="font-size: 11px;">Step 3</div> <div class="step-title ml-10" style="font-size: 12px;">SCHEDULE</div>
          </div>

          <el-row :gutter="20" class="mt-5">
            <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
              <label>Schedule SMS</label>
            </el-col>

            <el-col :xs="8" :sm="8" :md="6" :lg="6" :xl="6">
              <el-select v-model="schedule_type" style="width: 100%;" placeholder="Select schedule type" size="medium">
                <el-option label="Schedule now" value="Schedule now">Schedule Now</el-option>
                <el-option label="Schedule later" value="Schedule later">Schedule Later</el-option>
              </el-select>
            </el-col>

            <el-col :xs="8" :sm="8" :md="4" :lg="4" :xl="4" v-if="schedule_type == 'Schedule later'">
              <el-date-picker
                v-model="schedule_date"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="Schedule Date"
                size="medium"
                style="width: 100%;"
                v-validate="'required'"
                name="Schedule Date"
                :clearable="true"
              />

              <span
                v-show="errors.has('Schedule Date')"
                class="text-red-dark text-xs"
                >{{ errors.first("Schedule Date") }}</span
              >
            </el-col>

            <el-col :xs="8" :sm="8" :md="4" :lg="4" :xl="4" v-if="schedule_type == 'Schedule later'">
              <el-time-select style="width: 100%" placeholder="Schedule Time" v-model="schedule_time" size="medium" clearable v-validate="'required'" name="Schedule Time"
              :picker-options="{
                start: '00:00',
                end: '23:00'
              }"></el-time-select>

              <span
                v-show="errors.has('Schedule Time')"
                class="text-red-dark text-xs"
                >{{ errors.first("Schedule Time") }}</span
              >
            </el-col>
          </el-row>
        </div>

        <div class="footer mt-12 py-4 border-t border-solid border-black">
          <div class="flex justify-end">
            <BaseButton
              type="text"
              class="w-24 mr-4"
              buttonclass="btn p-2 text-xs"
              @click="selectNextStepOfCampaign('SELECT_PROMOTION_TYPE')"
            >
              Cancel
            </BaseButton>

            <BaseButton
              type="text"
              class="w-24 mr-4"
              buttonclass="btn p-2 text-xs"
              @click="selectNextStepOfCampaign('SELECT_COMMUNICATION_TYPE')"
            >
              Back
            </BaseButton>

            <BaseButton
              type="text"
              class="w-24"
              buttonclass="btn p-2 text-xs"
              @click="saveCommunicationNetworkCallBack()"
            >
              Next
            </BaseButton>
          </div>
        </div>
      </div>

      <!-- sales channel section -->
      <div class="body" v-if="form_action == 'SALES_CHANNEL_TYPE'">
        <div class="title">SALES CHANNEL</div>
        <div style="margin: 20px 0 20px 0;">
          <div style="width: 180px; margin: 0 auto;">
            <el-button
              type="text"
              class="btn text-xs"
              @click="setActiveSaleChannle('DINE_IN')"
              :class="[active_sales_channel == 'DINE_IN' ? 'active-btn' : '']"
              >
              DINE-IN
            </el-button>
          </div>

          <div style="width: 180px; margin: 15px auto;">
            <el-button
              type="text"
              class="btn"
              @click="setActiveSaleChannle('TAKE_AWAY')"
              :class="[active_sales_channel == 'TAKE_AWAY' ? 'active-btn' : '']"
              >
              TAKE AWAY
            </el-button>
          </div>

          <div style="width: 180px; margin: 15px auto;">
            <el-button
              type="text"
              class="btn"
              @click="setActiveSaleChannle('SWIGGY')"
              :class="[active_sales_channel == 'SWIGGY' ? 'active-btn' : '']"
              >
              SWIGGY
            </el-button>
          </div>

          <div style="width: 180px; margin: 15px auto;">
            <el-button
              type="text"
              class="btn"
              @click="setActiveSaleChannle('ZOMATO')"
              :class="[active_sales_channel == 'ZOMATO' ? 'active-btn' : '']"
              >
              ZOMATO
            </el-button>
          </div>
        </div>

        <div class="footer py-4 border-t border-solid border-black">
          <div class="flex justify-end">
            <BaseButton
              type="text"
              class="w-24 mr-4"
              buttonclass="btn p-2 text-xs"
              @click="selectNextStepOfCampaign('SELECT_PROMOTION_TYPE')"
            >
              Cancel
            </BaseButton>

            <!-- <BaseButton
              type="text"
              class="w-24 mr-4"
              buttonclass="btn p-2 text-xs"
              @click="openCreateCampaignDialog()"
            >
              Back
            </BaseButton> -->

            <BaseButton
              type="text"
              class="w-24"
              buttonclass="btn p-2 text-xs"
              @click="sendCommunicationForCampaign()"
            >
              Next
            </BaseButton>
          </div>
        </div>
      </div>
    </el-card>

    <el-card class="box-card success-campaign-box" v-if="form_action == 'SUCCESS'">
      <!-- <div class="body" v-if="form_action == 'SUCCESS'"> -->
      <div>
        <div class="text-center">
          <div>
            <i class="el-icon-circle-check" style="font-size: 50px; color: #e29d5a;"></i>
          </div>

          <div class="title mt-5">Your campaign is created successfully!</div>

          <BaseButton style="width: 180px; margin: 35px auto;" buttonclass="btn p-2 text-xs font-bold" @click="$router.push({ name: 'Campaign' }).catch(()=>{})">CAMPAIGNS HOME</BaseButton>
        </div>
      </div>

    </el-card>

    <!-- discount form dialog -->
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="true"
      width="80%"
      top="0"
      custom-class="customClass"
      :lock-scroll="true"
      :show-close="false"
    >
      <div class="discountForm">
        <div class="body" v-if="active_promotion == 'DISCOUNT'">
          <div class="title">DISCOUNT</div>
          <div class="content">
            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Store</label>
                </el-col>
                <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                  <el-select v-model="store" style="width: 100%" placeholder="Select Store" size="medium" filterable @change="getProductListByStoreIdNetWorkCallBack(store)" v-validate="'required'" name="Store">
                    <el-option v-for="(store, index) in store_list" :key="index" :label="store.name" :value="store.id" class="capitalize"></el-option>
                  </el-select>

                  <span
                    v-show="errors.has('Store')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("Store") }}</span
                  >
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Campaign Title</label>
                </el-col>
                <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                  <el-input v-model="campaign_title" v-validate="'required'" name="Campaign title" placeholder="Enter Campaign Name" size="medium"></el-input>

                  <span
                    v-show="errors.has('Campaign title')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("Campaign title") }}</span
                  >
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Product</label>
                </el-col>
                <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                  <el-select v-model="product" style="width: 100%" placeholder="Select Product" size="medium" filterable @change="getProductDetailsByProductIDNetworkCallBack(product)" v-validate="'required'" name="Product">
                    <el-option v-for="(product, product_index) in product_list" :key="product_index" :label="product.name" :value="product.id" class="capitalize"></el-option>
                  </el-select>

                  <span
                    v-show="errors.has('Product')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("Product") }}</span
                  >
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Discount Percentage</label>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-select
                    v-model="discount_percentage"
                    style="width: 100%"
                    placeholder="Select Percentage"
                    size="medium"
                    :clearable="true"
                    @change="applyDiscountToItems(discount_percentage)"
                  >
                    <el-option v-for="(discount, dis_index) in discount_list" :key="dis_index" :label="discount.label" :value="discount.value"></el-option>
                  </el-select>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-checkbox v-model="applicable_to_all" @change="applyDiscountToItems(discount_percentage)">Applicable To All</el-checkbox>
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <div class="campaignTable">
                <table>
                  <thead>
                    <th>CATEGORY</th>
                    <th>SUB CATEGORY</th>
                    <th>ITEM NAME</th>
                    <th>ITEM MRP</th>
                    <th>DISCOUNT %</th>
                    <th>DISCOUNTED PRICE</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, item_index) in item_list" :key="item_index">
                      <td class="capitalize">{{ item.category.name }}</td>
                      <td class="capitalize">{{ item.subcategory.name }}</td>
                      <td class="capitalize">
                        {{ item.name }}
                      </td>
                      <td>{{ item.price }}</td>
                      <td style="width: 200px">
                        <el-select
                          v-model="item.discount"
                          style="width: 100%"
                          placeholder="Select Percentage"
                          size="mini"
                          :clearable="true"
                          :disabled="applicable_to_all"
                          @change="applyDiscountFromItemTable(item_index, item.discount)"
                        >
                          <el-option v-for="(discount, dis_index1) in discount_list" :key="dis_index1" :label="discount.label" :value="discount.value"></el-option>
                        </el-select>
                      </td>
                      <td>{{ item.discounted_price }}</td>
                      <td>
                        <img src="../../../../assets/images/delete-icon.png" class="cursor-pointer" width="18" alt="Delete Item" @click="removeItemFromList(item_index)">
                      </td>
                    </tr>
                    <tr v-if="!item_list.length">
                      <td colspan="7" style="color: #e29d5a;">No Data</td>
                    </tr>
                  </tbody>
                </table>
                <!-- <div class="py-2 border-t border-solid border-black"></div> -->
              </div>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Frequency</label>
                </el-col>
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                  <el-radio v-model="frequency" label="recurring">Recurring</el-radio>
                </el-col>
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                  <el-radio v-model="frequency" label="limited">Limited Period</el-radio>
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-2" v-if="frequency != 'limited'">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Days</label>
                </el-col>

                <el-col :xs="18" :sm="18" :md="6" :lg="6" :xl="6">
                  <el-radio v-model="days" label="all" @change="discountable_days = []">All Days</el-radio>
                </el-col>

                <el-col :xs="18" :sm="18" :md="6" :lg="6" :xl="6">
                  <div class="flex">
                    <el-radio v-model="days" label="" style="margin-right: 5px;"></el-radio>

                    <el-select v-model="discountable_days" multiple style="width: 100%" placeholder="Select Day" size="medium" :disabled="days == 'all'">
                      <el-option v-for="(day, day_index) in day_list" :key="day_index" :label="day.title" :value="day.value"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Date</label>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-date-picker
                    v-model="from_date"
                    v-validate="'required'"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="Start Date"
                    size="medium"
                    style="width: 100%;"
                    name="From Date"
                    :picker-options="{
                      firstDayOfWeek: 1
                    }"
                  />

                  <span
                    v-show="errors.has('From Date')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("From Date") }}</span
                  >
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-date-picker
                    v-model="to_date"
                    v-validate="'required'"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="End Date"
                    size="medium"
                    style="width: 100%;"
                    name="To Date"
                    :picker-options="{
                      disabledDate: date => {
                        return date < from_date;
                      },
                      firstDayOfWeek: 1
                    }"
                  />

                   <span
                    v-show="errors.has('To Date')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("To Date") }}</span
                  >
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Time</label>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-time-select style="width: 100%" placeholder="Start Time" v-model="start_time" size="medium" v-validate="'required'" name="Start Time"
                  :picker-options="{
                    start: '00:00',
                    end: '23:00'
                  }"></el-time-select>

                  <span
                    v-show="errors.has('Start Time')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("Start Time") }}</span
                  >
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-time-select style="width: 100%" placeholder="End Time" v-model="end_time" size="medium" v-validate="'required'" name="End Time"
                  :picker-options="{
                    start: '00:00',
                    end: '23:00'
                  }"></el-time-select>

                  <span
                    v-show="errors.has('End Time')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("End Time") }}</span
                  >
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="footer mt-4 py-4 border-t border-solid border-black">
            <div class="flex justify-end">
              <BaseButton
                type="text"
                class="w-24 mr-4"
                buttonclass="btn p-2 text-xs"
                @click="selectNextStepOfCampaign('SELECT_PROMOTION_TYPE')"
              >
                Cancel
              </BaseButton>
              <BaseButton
                type="text"
                class="w-24"
                buttonclass="btn p-2 text-xs"
                @click="savePromotionNetWorkCallBack()"
              >
                <!-- @click="selectNextStepOfCampaign('SELECT_COMMUNICATION_TYPE')" -->
                Next
              </BaseButton>
            </div>
          </div>
        </div>

        <div class="body" v-if="active_promotion == 'COMBO'">
          <div class="title">COMBO</div>
          <div class="content">
            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Store</label>
                </el-col>
                <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                  <el-select v-model="store" style="width: 100%" placeholder="Select Store" size="medium" filterable @change="getProductListByStoreIdNetWorkCallBack(store)" v-validate="'required'" name="Store">
                    <el-option v-for="(store, index) in store_list" :key="index" :label="store.name" :value="store.id" class="capitalize"></el-option>
                  </el-select>

                  <span
                    v-show="errors.has('Store')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("Store") }}</span
                  >
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Campaign Title</label>
                </el-col>
                <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                  <el-input v-model="campaign_title" v-validate="'required'" name="Campaign title" placeholder="Enter Campaign Name" size="medium"></el-input>

                  <span
                    v-show="errors.has('Campaign title')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("Campaign title") }}</span
                  >
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <div class="campaignTable">
                <table>
                  <thead>
                    <th>COMBO NAME</th>
                    <th>ITEM NAME</th>
                    <th>ITEM PRICE</th>
                    <th>DISCOUNT%</th>
                    <th>DISCOUNTED PRICE</th>
                    <th>&nbsp;</th>
                  </thead>
                  <tbody v-for="(combo, combo_index) in combo_list" :key="combo_index" style="border-bottom: 1px solid #ddd;">

                    <tr v-for="(product, product_index1) in combo.product_list" :key="product_index1+'product'+new Date().getTime()">
                      <td style="border: none;" class="capitalize">
                        <div v-if="product_index1 == 0">
                          {{ combo.combo_name }}
                          <!-- <el-input v-model="combo.name" size="mini" placeholder="Enter combo name" style="width: 70%;"></el-input> -->
                        </div>
                        <div v-else>
                          &nbsp;
                        </div>
                      </td>
                      <td style="border: none;" class="capitalize">
                        <div class="font-bold">
                          {{ product.name }}
                        </div>
                        <div class="mt-1" style="">
                          <span>{{ product.category.name }}</span> - <span>{{ product.subcategory.name }}</span>
                        </div>
                      </td>
                      <td style="border: none;">{{ product.price }}</td>
                      <td style="border: none;">{{ product.discount ? product.discount : 0 }}</td>
                      <td style="border: none;">{{ product.discounted_price ? product.discounted_price : 0 }}</td>
                      <td style="border: none;" v-if="product.name">
                        <img src="../../../../assets/images/delete-icon.png" class="cursor-pointer" width="18" alt="Delete Item" @click="removeItemFromComboList(combo_index, product_index1)">
                      </td>
                    </tr>

                    <tr v-for="(item, item_index) in combo.select_item_list" :key="item_index">
                      <td style="border: none;">
                        <el-input v-if="!combo.product_list.length && item_index == 0" v-model="combo.combo_name" size="mini" placeholder="Enter combo name" style="width: 100%;"></el-input>

                        <div v-else>&nbsp;</div>
                      </td>
                      <td style="border: none;">
                        <el-select v-model="item.item_id" style="width: 100%;" placeholder="Select Product" size="mini" filterable @change="getProductDetailsByProductIDNetworkCallBack(item.item_id, combo_index, item_index)">
                          <el-option v-for="(prod, index1) in product_list" :key="index1+'Product'+item_index" :label="prod.name" :value="prod.id" class="capitalize"></el-option>
                        </el-select>
                      </td>
                      <td style="border: none;">{{ item.selected_items.price }}</td>
                      <td style="border: none;">
                        <el-select
                          v-model="item.discount"
                          style="width: 70%;"
                          placeholder="Percentage"
                          size="mini"
                          :clearable="true"
                          :disabled="!item.item_id"
                          @change="applyDiscountFromCOMBOTable(item.discount, item_index, combo_index)"
                        >
                          <el-option v-for="(discount, dis_index1) in discount_list" :key="dis_index1" :label="discount.label" :value="discount.value"></el-option>
                        </el-select>
                      </td>
                      <td style="border: none;">{{ item.selected_items.discounted_price }}</td>
                      <td style="border: none;">
                        <button class="mini-button" @click="addProductInItemList(item.selected_items, combo_index, item_index)">OK</button>
                      </td>
                    </tr>

                    <tr>
                      <td style="border: none;">&nbsp;</td>
                      <td style="border: none;">
                        <BaseButton
                          type="text"
                          class="w-24 ml-auto mr-auto"
                          buttonclass="btn p-2 text-xs"
                          @click="addItemInSelectItemList(combo_index)"
                        >
                        ADD ITEM
                        </BaseButton>
                      </td>
                      <td style="border: none;">
                        <div class="font-bold" style="font-size: 10px;">TOTAL</div>
                        <div class="mt-1">
                          {{ combo.combo_total }}
                          <!-- {{ getTotalOfAddedComboProducts(combo_index) }} -->
                        </div>
                      </td>
                      <td style="border: none;">
                        <div class="font-bold" style="font-size: 10px;">AVG DISCOUNT</div>
                         <div class="mt-1">
                          {{ combo.avg_discount }}
                          <!-- {{ getAVGOfTotalDiscountAddedComboProducts(combo_index) }} -->
                         </div>
                      </td>
                      <td style="border: none;">
                        <div class="font-bold" style="font-size: 10px;">COMBO PRICE</div>
                         <div class="mt-1">
                           <!-- {{ getDiscountedTotalCOMBOPrice(combo_index) }} -->
                          {{ combo.combo_price }}
                         </div>
                        <!-- <el-input v-model="combo.combo_price" size="mini" placeholder="Combo price" class="mt-1" style="width: 100px;"></el-input> -->
                      </td>
                      <td style="border: none;">&nbsp;</td>
                    </tr>

                    <!-- <tr v-if="!combo.product_list.length && combo_index > 1"> -->
                    <tr v-if="combo.product_list.length && combo_list.length -1 == combo_index">
                      <td style="border-bottom: none;" colspan="6">
                        <BaseButton
                          type="text"
                          style="width: 120px;"
                          buttonclass="btn p-2 text-xs"
                          @click="addOneMoreComboInComboList()"
                        >
                          ADD COMBO {{ combo_index + 2 }}
                        </BaseButton>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- <div class="py-2 border-t border-solid border-black"></div> -->
              </div>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Frequency</label>
                </el-col>
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                  <el-radio v-model="frequency" label="recurring">Recurring</el-radio>
                </el-col>
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                  <el-radio v-model="frequency" label="limited">Limited Period</el-radio>
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-2" v-if="frequency != 'limited'">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Days</label>
                </el-col>

                <el-col :xs="18" :sm="18" :md="6" :lg="6" :xl="6">
                  <el-radio v-model="days" label="all" @change="discountable_days = []">All Days</el-radio>
                </el-col>

                <el-col :xs="18" :sm="18" :md="6" :lg="6" :xl="6">
                  <div class="flex">
                    <el-radio v-model="days" label="" style="margin-right: 5px;"></el-radio>

                    <el-select v-model="discountable_days" multiple style="width: 100%" placeholder="Select Day" size="medium" :disabled="days == 'all'">
                      <el-option v-for="(day, day_index) in day_list" :key="day_index" :label="day.title" :value="day.value"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Date</label>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-date-picker
                    v-model="from_date"
                    v-validate="'required'"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="Start Date"
                    size="medium"
                    style="width: 100%;"
                    name="From Date"
                    :picker-options="{
                      firstDayOfWeek: 1
                    }"
                  />

                  <span
                    v-show="errors.has('From Date')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("From Date") }}</span
                  >
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-date-picker
                    v-model="to_date"
                    v-validate="'required'"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="End Date"
                    size="medium"
                    style="width: 100%;"
                    name="To Date"
                    :picker-options="{
                      disabledDate: date => {
                        return date < from_date;
                      },
                      firstDayOfWeek: 1
                    }"
                  />

                   <span
                    v-show="errors.has('To Date')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("To Date") }}</span
                  >
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Time</label>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-time-select style="width: 100%" placeholder="Start Time" v-model="start_time" size="medium" v-validate="'required'" name="Start Time"
                  :picker-options="{
                    start: '00:00',
                    end: '23:00'
                  }"></el-time-select>

                  <span
                    v-show="errors.has('Start Time')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("Start Time") }}</span
                  >
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-time-select style="width: 100%" placeholder="End Time" v-model="end_time" size="medium" v-validate="'required'" name="End Time"
                  :picker-options="{
                    start: '00:00',
                    end: '23:00'
                  }"></el-time-select>

                  <span
                    v-show="errors.has('End Time')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("End Time") }}</span
                  >
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="footer mt-4 py-4 border-t border-solid border-black">
            <div class="flex justify-end">
              <BaseButton
                type="text"
                class="w-24 mr-4"
                buttonclass="btn p-2 text-xs"
                @click="selectNextStepOfCampaign('SELECT_PROMOTION_TYPE')"
              >
                Cancel
              </BaseButton>
              <BaseButton
                type="text"
                class="w-24"
                buttonclass="btn p-2 text-xs"
                @click="savePromotionNetWorkCallBack()"
              >
                <!-- @click="selectNextStepOfCampaign('SELECT_COMMUNICATION_TYPE')" -->
                Next
              </BaseButton>
            </div>
          </div>
        </div>

        <div class="body" v-if="active_promotion == 'BUY X & GET Y'">
          <div class="title">BUY X & GET Y</div>
          <div class="content">
            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Store</label>
                </el-col>
                <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                  <el-select v-model="store" style="width: 100%" placeholder="Select Store" size="medium" filterable @change="getProductListByStoreIdNetWorkCallBack(store)" v-validate="'required'" name="Store">
                    <el-option v-for="(store, index) in store_list" :key="index" :label="store.name" :value="store.id" class="capitalize"></el-option>
                  </el-select>

                  <span
                    v-show="errors.has('Store')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("Store") }}</span
                  >
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Offer</label>
                </el-col>
                <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                  <el-select v-model="select_offer" style="width: 100%" placeholder="Select Offer" size="medium" v-validate="'required'" name="Offer" @change="changeOfferType(select_offer)">
                    <el-option v-for="(offer, index) in offer_list" :key="index" :label="offer.title" :value="offer.title" class="capitalize"></el-option>
                  </el-select>

                  <span
                    v-show="errors.has('Offer')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("Offer") }}</span
                  >
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Campaign Title</label>
                </el-col>
                <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                  <el-input v-model="campaign_title" v-validate="'required'" name="Campaign title" placeholder="Enter Campaign Name" size="medium"></el-input>

                  <span
                    v-show="errors.has('Campaign title')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("Campaign title") }}</span
                  >
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <div class="campaignTable">
                <table>
                  <thead>
                    <th>&nbsp;</th>
                    <th>TYPE</th>
                    <th>ITEM NAME</th>
                    <th>ITEM PRICE</th>
                    <th>DISCOUNT%</th>
                    <th>DISCOUNTED PRICE</th>
                    <th>&nbsp;</th>
                  </thead>
                  <tbody v-for="(item, xy_index) in productXY_list" :key="xy_index" style="border-bottom: 1px solid #ddd;">

                    <tr v-for="(x_product, x_product_index) in item.x_product_list" :key="x_product_index+'x_product'+new Date().getTime()">
                      <td style="border: none;">{{ x_product_index + 1 }}</td>
                      <td style="border: none;" class="capitalize">
                        <div class="font-bold">
                          {{ x_product.product_type }}
                        </div>
                      </td>
                      <td style="border: none;" class="capitalize">
                        <div class="font-bold">
                          {{ x_product.name }}
                        </div>
                        <div class="mt-1" style="">
                          <span>{{ x_product.category.name }}</span> - <span>{{ x_product.subcategory.name }}</span>
                        </div>
                      </td>
                      <td style="border: none;">{{ x_product.price }}</td>
                      <td style="border: none;">-</td>
                      <td style="border: none;">-</td>
                      <td style="border: none;" v-if="x_product.name">
                        <img src="../../../../assets/images/delete-icon.png" class="cursor-pointer" width="18" alt="Delete Item" @click="removeItemFromXProductList(xy_index, x_product_index)">
                      </td>
                    </tr>

                    <tr v-for="(select_x_product, select_x_product_index) in item.select_x_item_list" :key="select_x_product_index+'select_x_product'+new Date().getTime()">
                      <td style="border: none;">{{ select_x_product_index + 1 }}</td>
                      <td style="border: none;" class="capitalize">
                        <div class="font-bold">
                          {{ select_x_product.product_type }}
                        </div>
                      </td>
                      <td style="border: none;">
                        <el-select v-model="select_x_product.item_id" style="width: 100%;" placeholder="Select Product" size="mini" filterable @change="getProductDetailsByProductIDForXYProductTypeNetworkCallBack(select_x_product.item_id, xy_index, select_x_product_index, 'X_product')">
                          <el-option v-for="(prod, index1) in product_list" :key="index1+'Product'+select_x_product_index" :label="prod.name" :value="prod.id" class="capitalize"></el-option>
                        </el-select>
                      </td>
                      <td style="border: none;">{{ select_x_product.selected_items.price }}</td>
                      <td style="border: none;">-</td>
                      <td style="border: none;">-</td>
                      <td style="border: none;">
                        <button class="mini-button" @click="addSelectedProductInXItemList(select_x_product.selected_items, xy_index, select_x_product_index)">OK</button>
                      </td>
                    </tr>


                    <tr v-for="(y_product, y_product_index) in item.y_product_list" :key="y_product_index+'y_product'+new Date().getTime()">
                      <td style="border: none;">{{ y_product_index + 1 }}</td>
                      <td style="border: none;" class="capitalize">
                        <div class="font-bold">
                          {{ y_product.product_type }}
                        </div>
                      </td>
                      <td style="border: none;" class="capitalize">
                        <div class="font-bold">
                          {{ y_product.name }}
                        </div>
                        <div class="mt-1" style="">
                          <span>{{ y_product.category.name }}</span> - <span>{{ y_product.subcategory.name }}</span>
                        </div>
                      </td>
                      <td style="border: none;">{{ y_product.price }}</td>
                      <td style="border: none;">{{ y_product.discount }}</td>
                      <td style="border: none;">
                        <div v-if="y_product.discount < 100">
                          {{ y_product.discounted_price }}
                        </div>

                        <div v-if="y_product.discount == 100">
                          Free
                        </div>
                      </td>
                      <td style="border: none;" v-if="y_product.name">
                        <img src="../../../../assets/images/delete-icon.png" class="cursor-pointer" width="18" alt="Delete Item" @click="removeItemFromYProductList(xy_index, y_product_index)">
                      </td>
                    </tr>

                    <tr v-for="(select_y_product, select_y_product_index) in item.select_y_item_list" :key="select_y_product_index+'select_y_product'+new Date().getTime()">
                      <td style="border: none;">{{ select_y_product_index + 1 }}</td>
                      <td style="border: none;" class="capitalize">
                        <div class="font-bold">
                          {{ select_y_product.product_type }}
                        </div>
                      </td>
                      <td style="border: none;">
                        <el-select v-model="select_y_product.item_id" style="width: 100%;" placeholder="Select Product" size="mini" filterable @change="getProductDetailsByProductIDForXYProductTypeNetworkCallBack(select_y_product.item_id, xy_index, select_y_product_index, 'Y_product')">
                          <el-option v-for="(prod, index1) in product_list" :key="index1+'Product'+select_y_product_index" :label="prod.name" :value="prod.id" class="capitalize"></el-option>
                        </el-select>
                      </td>
                      <td style="border: none;">{{ select_y_product.selected_items.price }}</td>
                      <td style="border: none;">
                        <el-select
                          v-model="select_y_product.discount"
                          style="width: 70%;"
                          placeholder="Percentage"
                          size="mini"
                          :clearable="true"
                          :disabled="!select_y_product.item_id"
                          @change="applyDiscountFromBuyXYable(select_y_product.discount, select_y_product_index, xy_index)"
                        >
                          <el-option v-for="(discount, dis_index1) in discount_list" :key="dis_index1" :label="discount.label" :value="discount.value"></el-option>
                        </el-select>
                      </td>
                      <td style="border: none;">
                        <div v-if="select_y_product.discount < 100">
                          {{ select_y_product.selected_items.discounted_price }}
                        </div>
                        <div v-if="select_y_product.discount == 100">
                          Free
                        </div>
                      </td>
                      <td style="border: none;">
                        <button class="mini-button" @click="addSelectedProductInYItemList(select_y_product.selected_items, xy_index, select_y_product_index)">OK</button>
                      </td>
                    </tr>

                    <tr v-if="item.x_product_list.length && item.y_product_list.length && productXY_list.length -1 == xy_index">
                      <td>&nbsp;</td>
                      <td colspan="7">
                        <BaseButton
                          type="text"
                          style="width: 120px;"
                          buttonclass="btn p-2 text-xs"
                          @click="addMoreItemsInXYList(xy_index)"
                        >
                          ADD MORE
                        </BaseButton>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Frequency</label>
                </el-col>
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                  <el-radio v-model="frequency" label="recurring">Recurring</el-radio>
                </el-col>
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                  <el-radio v-model="frequency" label="limited">Limited Period</el-radio>
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-2" v-if="frequency != 'limited'">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Days</label>
                </el-col>

                <el-col :xs="18" :sm="18" :md="6" :lg="6" :xl="6">
                  <el-radio v-model="days" label="all" @change="discountable_days = []">All Days</el-radio>
                </el-col>

                <el-col :xs="18" :sm="18" :md="6" :lg="6" :xl="6">
                  <div class="flex">
                    <el-radio v-model="days" label="" style="margin-right: 5px;"></el-radio>

                    <el-select v-model="discountable_days" multiple style="width: 100%" placeholder="Select Day" size="medium" :disabled="days == 'all'">
                      <el-option v-for="(day, day_index) in day_list" :key="day_index" :label="day.title" :value="day.value"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Date</label>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-date-picker
                    v-model="from_date"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="Start Date"
                    size="medium"
                    style="width: 100%;"
                    v-validate="'required'"
                    name="From Date"
                  />

                  <span
                    v-show="errors.has('From Date')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("From Date") }}</span
                  >
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-date-picker
                    v-model="to_date"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="End Date"
                    size="medium"
                    style="width: 100%;"
                    v-validate="'required'"
                    name="To Date"
                  />

                   <span
                    v-show="errors.has('To Date')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("To Date") }}</span
                  >
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Time</label>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-time-select style="width: 100%" placeholder="Start Time" v-model="start_time" size="medium" v-validate="'required'" name="Start Time"
                  :picker-options="{
                    start: '00:00',
                    end: '23:00'
                  }"></el-time-select>

                  <span
                    v-show="errors.has('Start Time')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("Start Time") }}</span
                  >
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-time-select style="width: 100%" placeholder="End Time" v-model="end_time" size="medium" v-validate="'required'" name="End Time"
                  :picker-options="{
                    start: '00:00',
                    end: '23:00'
                  }"></el-time-select>

                  <span
                    v-show="errors.has('End Time')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("End Time") }}</span
                  >
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="footer mt-4 py-4 border-t border-solid border-black">
            <div class="flex justify-end">
              <BaseButton
                type="text"
                class="w-24 mr-4"
                buttonclass="btn p-2 text-xs"
                @click="selectNextStepOfCampaign('SELECT_PROMOTION_TYPE')"
              >
                Cancel
              </BaseButton>
              <BaseButton
                type="text"
                class="w-24"
                buttonclass="btn p-2 text-xs"
                @click="savePromotionNetWorkCallBack()"
              >
                <!-- @click="selectNextStepOfCampaign('SELECT_COMMUNICATION_TYPE')" -->
                Next
              </BaseButton>
            </div>
          </div>
        </div>

        <div class="body" v-if="active_promotion == 'NEAR EXPIRY'">
          <div class="title">NEAR EXPIRY</div>
          <div class="content">
            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Store</label>
                </el-col>
                <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                  <el-select v-model="store" style="width: 100%" placeholder="Select Store" size="medium" filterable @change="getProductListByStoreIdNetWorkCallBack(store)" v-validate="'required'" name="Store">
                    <el-option v-for="(store, index) in store_list" :key="index" :label="store.name" :value="store.id" class="capitalize"></el-option>
                  </el-select>

                  <span
                    v-show="errors.has('Store')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("Store") }}</span
                  >
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Campaign Title</label>
                </el-col>
                <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                  <el-input v-model="campaign_title" v-validate="'required'" name="Campaign title" placeholder="Enter Campaign Name" size="medium"></el-input>

                  <span
                    v-show="errors.has('Campaign title')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("Campaign title") }}</span
                  >
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Near Expiry Item</label>
                </el-col>
                <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                  <el-select v-model="product" style="width: 100%" placeholder="Select Product" size="medium" filterable @change="getProductDetailsByProductIDNetworkCallBack(product)" v-validate="'required'" name="Product">
                    <el-option v-for="(product, product_index) in product_list" :key="product_index" :label="product.item_name" :value="product.article_id" class="capitalize"></el-option>
                  </el-select>

                  <span
                    v-show="errors.has('Product')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("Product") }}</span
                  >
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Discount Percentage</label>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-select
                    v-model="discount_percentage"
                    style="width: 100%"
                    placeholder="Select Percentage"
                    size="medium"
                    :clearable="true"
                    @change="applyDiscountToItems(discount_percentage)"
                  >
                    <el-option v-for="(discount, dis_index) in discount_list" :key="dis_index" :label="discount.label" :value="discount.value"></el-option>
                  </el-select>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-checkbox v-model="applicable_to_all" @change="applyDiscountToItems(discount_percentage)">Applicable To All</el-checkbox>
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <div class="campaignTable">
                <table>
                  <thead>
                    <th>CATEGORY</th>
                    <th>SUB CATEGORY</th>
                    <th>ITEM NAME</th>
                    <th>EXPIRY DATE</th>
                    <th>ITEM MRP</th>
                    <th>DISCOUNT %</th>
                    <th>DISCOUNTED PRICE</th>
                    <th>&nbsp;</th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, item_index) in item_list" :key="item_index">
                      <td class="capitalize">{{ item.category.name }}</td>
                      <td class="capitalize">{{ item.subcategory.name }}</td>
                      <td class="capitalize">
                        {{ item.name }}
                      </td>
                      <td>18-08-2020</td>
                      <td>{{ item.price }}</td>
                      <td style="width: 200px">
                        <el-select
                          v-model="item.discount"
                          style="width: 100%"
                          placeholder="Select Percentage"
                          size="mini"
                          :clearable="true"
                          :disabled="applicable_to_all"
                          @change="applyDiscountFromItemTable(item_index, item.discount)"
                        >
                          <el-option v-for="(discount, dis_index1) in discount_list" :key="dis_index1" :label="discount.label" :value="discount.value"></el-option>
                        </el-select>
                      </td>
                      <td>{{ item.discounted_price }}</td>
                      <td>
                        <img src="../../../../assets/images/delete-icon.png" class="cursor-pointer" width="18" alt="Delete Item" @click="removeItemFromList(item_index)">
                      </td>
                    </tr>
                    <tr v-if="!item_list.length">
                      <td colspan="7" style="color: #e29d5a;">No Data</td>
                    </tr>
                  </tbody>
                </table>
                <!-- <div class="py-2 border-t border-solid border-black"></div> -->
              </div>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Frequency</label>
                </el-col>
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                  <el-radio v-model="frequency" label="recurring">Recurring</el-radio>
                </el-col>
                <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                  <el-radio v-model="frequency" label="limited">Limited Period</el-radio>
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-2" v-if="frequency != 'limited'">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Days</label>
                </el-col>

                <el-col :xs="18" :sm="18" :md="6" :lg="6" :xl="6">
                  <el-radio v-model="days" label="all" @change="discountable_days = []">All Days</el-radio>
                </el-col>

                <el-col :xs="18" :sm="18" :md="6" :lg="6" :xl="6">
                  <div class="flex">
                    <el-radio v-model="days" label="" style="margin-right: 5px;"></el-radio>

                    <el-select v-model="discountable_days" multiple style="width: 100%" placeholder="Select Day" size="medium" :disabled="days == 'all'">
                      <el-option v-for="(day, day_index) in day_list" :key="day_index" :label="day.title" :value="day.value"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Date</label>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-date-picker
                    v-model="from_date"
                    v-validate="'required'"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="Start Date"
                    size="medium"
                    style="width: 100%;"
                    name="From Date"
                    :picker-options="{
                      firstDayOfWeek: 1
                    }"
                  />

                  <span
                    v-show="errors.has('From Date')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("From Date") }}</span
                  >
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-date-picker
                    v-model="to_date"
                    v-validate="'required'"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="End Date"
                    size="medium"
                    style="width: 100%;"
                    name="To Date"
                    :picker-options="{
                      disabledDate: date => {
                        return date < from_date;
                      },
                      firstDayOfWeek: 1
                    }"
                  />

                   <span
                    v-show="errors.has('To Date')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("To Date") }}</span
                  >
                </el-col>
              </el-row>
            </div>

            <div class="divider mt-5">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <label>Select Time</label>
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-time-select style="width: 100%" placeholder="Start Time" v-model="start_time" size="medium" v-validate="'required'" name="Start Time"
                  :picker-options="{
                    start: '00:00',
                    end: '23:00'
                  }"></el-time-select>

                  <span
                    v-show="errors.has('Start Time')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("Start Time") }}</span
                  >
                </el-col>
                <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
                  <el-time-select style="width: 100%" placeholder="End Time" v-model="end_time" size="medium" v-validate="'required'" name="End Time"
                  :picker-options="{
                    start: '00:00',
                    end: '23:00'
                  }"></el-time-select>

                  <span
                    v-show="errors.has('End Time')"
                    class="text-red-dark text-xs"
                    >{{ errors.first("End Time") }}</span
                  >
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="footer mt-4 py-4 border-t border-solid border-black">
            <div class="flex justify-end">
              <BaseButton
                type="text"
                class="w-24 mr-4"
                buttonclass="btn p-2 text-xs"
                @click="selectNextStepOfCampaign('SELECT_PROMOTION_TYPE')"
              >
                Cancel
              </BaseButton>
              <BaseButton
                type="text"
                class="w-24"
                buttonclass="btn p-2 text-xs"
                @click="savePromotionNetWorkCallBack()"
              >
                <!-- @click="selectNextStepOfCampaign('SELECT_COMMUNICATION_TYPE')" -->
                Next
              </BaseButton>
            </div>
          </div>
        </div>
      </div>
      <!-- <campaign-discount :store_list="store_list" :dialog_visible="dialogVisible" @closeDialog="dialogVisible=false"></campaign-discount> -->
    </el-dialog>
  </div>
</template>

<script>
import LabourPalnningService from "../../../../services/labourPalnningService";
import ArticleMasterService from "../../../../services/articleMasterService";
import { EventBus } from "../../../../eventBus";
import { EmailEditor } from 'vue-email-editor';
import CampaignsService from "../../../../services/campaignsService";
import ExpiryService from "../../../../services/expiryService";
import { mapActions, mapState } from "vuex";
import moment from 'moment';
var _ = require('lodash');

// import sample from "../../../../../node_modules/vue-email-editor/src/data/sample.json";

export default {
  name: "CreateCampaign",
  components: {
    EmailEditor
  },
  props:["storeId"],
  data: () => {
    return {
      dialogVisible: false,
      campaign_progress: 0,
      store_list: [],
      store: '',
      campaign_title: '',
      product: "",
      discount_percentage: '',
      days: 'all',
      applicable_to_all: false,
      frequency: 'recurring',
      email_content: '',
      sms_content: '',
      active_promotion: '',
      selected_promotion_id: '',
      promo_type_list: [
        {
          title: 'DISCOUNT',
          id: '36b0c737-293d-476e-80c3-76eab7c01cb3'
        },
        {
          title: 'BUY X & GET Y',
          id: '2e8e6bd7-0d44-440e-812f-c5dc8d4a0d8c'
        },
        {
          title: 'COMBO',
          id: '2f7516b1-2d5f-4036-a866-8e8447344c19'
        },
        {
          title: 'NEAR EXPIRY',
          id: '08848a13-e27c-4de9-9096-9cfd9951ca9b'
        },
      ],
// 0	2e8e6bd7-0d44-440e-812f-c5dc8d4a0d8c	Buy X get Y
// 1	2f7516b1-2d5f-4036-a866-8e8447344c19	COMBO
// 2	36b0c737-293d-476e-80c3-76eab7c01cb3	Discount
// 3	08848a13-e27c-4de9-9096-9cfd9951ca9b	NEAR EXPIRY

      discountable_days: [],
      product_list: [],
      day_list: [
        {
          title: 'Monday',
          value: 0
        },{
          title: 'Tuesday',
          value: 1
        },
        {
          title: 'Wednesday',
          value: 2
        },{
          title: 'Thursday',
          value: 3
        },{
          title: 'Friday',
          value: 4
        },{
          title: 'Saturday',
          value: 5
        },{
          title: 'Sunday',
          value: 6
        }
      ],
      item_list: [],
      combo_list: [
        {
          product_list: [],
          select_item_list : [
            {
              item_id: '',
              selected_items: {},
              // price: '',
              discount: '',
              discounted_price: ''
            },
            {
              item_id: '',
              selected_items: {},
              // price: '',
              discount: '',
              discounted_price: ''
            }
          ],

          combo_name: '',
          combo_total: '',
          combo_price: '',
          avg_discount: ''
        }
      ],

      productXY_list: [
        {
          x_product_list: [],
          y_product_list: [],
          select_x_item_list: [],
          select_y_item_list: [],
        }
      ],
      selected_product: [],
      discount_list: [
        {
          label: 5,
          value: 5
        },{
          label: 10,
          value: 10
        },{
          label: 15,
          value: 15
        },{
          label: 20,
          value: 20
        },{
          label: 25,
          value: 25
        },{
          label: 30,
          value: 30
        },{
          label: 35,
          value: 35
        },{
          label: 40,
          value: 40
        },{
          label: 45,
          value: 45
        },{
          label: 50,
          value: 50
        },{
          label: 55,
          value: 55
        },{
          label: 60,
          value: 60
        },{
          label: 65,
          value: 65
        },{
          label: 70,
          value: 70
        },{
          label: 75,
          value: 75
        },{
          label: 80,
          value: 80
        },{
          label: 85,
          value: 85
        },{
          label: 90,
          value: 90
        },{
          label: 95,
          value: 95
        },{
          label: 100,
          value: 100
        },
      ],
      email_id_input_list: [
        {
          email_id: ''
        },
        {
          email_id: ''
        },
        {
          email_id: ''
        }
      ],
      mobile_no_input_list: [
        {
          mobile_no: ''
        },
        {
          mobile_no: ''
        },
        {
          mobile_no: ''
        }
      ],
      sms_template_list: [
        {
          title: "Hudson's discount promotion",
          template: "Thank you for visiting Hudson's  Coffee. We can’t wait to see you again. Take 25% off on your next purchase with this coupon code - HCSU25"
        },
        {
          title: "Hudson Coffee Donut",
          template: "The hot light is on! Come in and get a fresh donut and we’ll give you a free cup of a coffee. Offer only good for the next three hours. Use code HOTDONUT"
        },
      ],
      email_template_list: [
        {
          title: 'Near Expiry - Cheesecake',
          email_title: 'NymbleUp - Cheesecake it is!',
          content: {
            "counters": {
                "u_column": 1,
                "u_row": 1,
                "u_content_image": 1
            },
            "body": {
                "rows": [{
                    "cells": [1],
                    "columns": [{
                        "contents": [{
                            "type": "image",
                            "values": {
                                "containerPadding": "10px",
                                "_meta": {
                                    "htmlID": "u_content_image_1",
                                    "htmlClassNames": "u_content_image"
                                },
                                "selectable": true,
                                "draggable": true,
                                "duplicatable": true,
                                "deletable": true,
                                "src": {
                                    "url": "https://unroll-images-production.s3.amazonaws.com/projects/5523/1597042491077-Near%20Expiry.jpg",
                                    "width": 1587,
                                    "height": 2245
                                },
                                "textAlign": "center",
                                "altText": "Image",
                                "action": {
                                    "name": "web",
                                    "values": {
                                        "href": "",
                                        "target": "_blank"
                                    }
                                },
                                "hideDesktop": false,
                                "hideMobile": false
                            }
                        }],
                        "values": {
                            "border": {},
                            "padding": "0px",
                            "backgroundColor": "",
                            "_meta": {
                                "htmlID": "u_column_1",
                                "htmlClassNames": "u_column"
                            }
                        }
                    }],
                    "values": {
                        "columns": false,
                        "backgroundColor": "",
                        "columnsBackgroundColor": "",
                        "backgroundImage": {
                            "url": "",
                            "fullWidth": true,
                            "repeat": false,
                            "center": true,
                            "cover": false
                        },
                        "padding": "0px",
                        "hideDesktop": false,
                        "hideMobile": false,
                        "noStackMobile": false,
                        "_meta": {
                            "htmlID": "u_row_1",
                            "htmlClassNames": "u_row"
                        },
                        "selectable": true,
                        "draggable": true,
                        "duplicatable": true,
                        "deletable": true
                    }
                }],
                "values": {
                    "backgroundColor": "#e7e7e7",
                    "backgroundImage": {
                        "url": "",
                        "fullWidth": true,
                        "repeat": false,
                        "center": true,
                        "cover": false
                    },
                    "contentWidth": "500px",
                    "fontFamily": {
                        "label": "Arial",
                        "value": "arial,helvetica,sans-serif"
                    },
                    "linkStyle": {
                        "body": true,
                        "linkColor": "#0000ee",
                        "linkHoverColor": "#0000ee",
                        "linkUnderline": true,
                        "linkHoverUnderline": true
                    },
                    "_meta": {
                        "htmlID": "u_body",
                        "htmlClassNames": "u_body"
                    }
                }
            },
            "schemaVersion": 5
        }
        },
        {
          title: "NymbleUp Friday's - Pizza",
          email_title: "NymbleUp Friday's - It's Pizza Time!",
          content: {
            "counters": {
              "u_column": 1,
              "u_row": 1,
              "u_content_image": 1
            },
            "body": {
                "rows": [{
                    "cells": [1],
                    "columns": [{
                        "contents": [{
                            "type": "image",
                            "values": {
                                "containerPadding": "10px",
                                "_meta": {
                                    "htmlID": "u_content_image_1",
                                    "htmlClassNames": "u_content_image"
                                },
                                "selectable": true,
                                "draggable": true,
                                "duplicatable": true,
                                "deletable": true,
                                "src": {
                                    "url": "https://unroll-images-production.s3.amazonaws.com/projects/5523/1597039332015-Nymbleup%20pizza.jpg",
                                    "width": 1587,
                                    "height": 2245
                                },
                                "textAlign": "center",
                                "altText": "Image",
                                "action": {
                                    "name": "web",
                                    "values": {
                                        "href": "",
                                        "target": "_blank"
                                    }
                                },
                                "hideDesktop": false,
                                "hideMobile": false
                            }
                        }],
                        "values": {
                            "border": {},
                            "padding": "0px",
                            "backgroundColor": "",
                            "_meta": {
                                "htmlID": "u_column_1",
                                "htmlClassNames": "u_column"
                            }
                        }
                    }],
                    "values": {
                        "columns": false,
                        "backgroundColor": "",
                        "columnsBackgroundColor": "",
                        "backgroundImage": {
                            "url": "",
                            "fullWidth": true,
                            "repeat": false,
                            "center": true,
                            "cover": false
                        },
                        "padding": "0px",
                        "hideDesktop": false,
                        "hideMobile": false,
                        "noStackMobile": false,
                        "_meta": {
                            "htmlID": "u_row_1",
                            "htmlClassNames": "u_row"
                        },
                        "selectable": true,
                        "draggable": true,
                        "duplicatable": true,
                        "deletable": true
                    }
                }],
                "values": {
                    "backgroundColor": "#e7e7e7",
                    "backgroundImage": {
                        "url": "",
                        "fullWidth": true,
                        "repeat": false,
                        "center": true,
                        "cover": false
                    },
                    "contentWidth": "500px",
                    "fontFamily": {
                        "label": "Arial",
                        "value": "arial,helvetica,sans-serif"
                    },
                    "linkStyle": {
                        "body": true,
                        "linkColor": "#0000ee",
                        "linkHoverColor": "#0000ee",
                        "linkUnderline": true,
                        "linkHoverUnderline": true
                    },
                    "_meta": {
                        "htmlID": "u_body",
                        "htmlClassNames": "u_body"
                    }
                }
            },
            "schemaVersion": 5
          }
        },
        {
          title: 'Freshly Brewed',
          email_title: "NymbleUp Freshly Brewed!",
          content:{
            "counters": {
              "u_column": 1,
              "u_row": 1,
              "u_content_image": 1
            },
            "body": {
                "rows": [{
                    "cells": [1],
                    "columns": [{
                        "contents": [{
                            "type": "image",
                            "values": {
                                "containerPadding": "10px",
                                "_meta": {
                                    "htmlID": "u_content_image_1",
                                    "htmlClassNames": "u_content_image"
                                },
                                "selectable": true,
                                "draggable": true,
                                "duplicatable": true,
                                "deletable": true,
                                "src": {
                                    "url": "https://unroll-images-production.s3.amazonaws.com/projects/5523/1597039129991-Nymbleup%20coffee.jpg",
                                    "width": 1587,
                                    "height": 2245
                                },
                                "textAlign": "center",
                                "altText": "Image",
                                "action": {
                                    "name": "web",
                                    "values": {
                                        "href": "",
                                        "target": "_blank"
                                    }
                                },
                                "hideDesktop": false,
                                "hideMobile": false
                            }
                        }],
                        "values": {
                            "border": {},
                            "padding": "0px",
                            "backgroundColor": "",
                            "_meta": {
                                "htmlID": "u_column_1",
                                "htmlClassNames": "u_column"
                            }
                        }
                    }],
                    "values": {
                        "columns": false,
                        "backgroundColor": "",
                        "columnsBackgroundColor": "",
                        "backgroundImage": {
                            "url": "",
                            "fullWidth": true,
                            "repeat": false,
                            "center": true,
                            "cover": false
                        },
                        "padding": "0px",
                        "hideDesktop": false,
                        "hideMobile": false,
                        "noStackMobile": false,
                        "_meta": {
                            "htmlID": "u_row_1",
                            "htmlClassNames": "u_row"
                        },
                        "selectable": true,
                        "draggable": true,
                        "duplicatable": true,
                        "deletable": true
                    }
                }],
                "values": {
                    "backgroundColor": "#e7e7e7",
                    "backgroundImage": {
                        "url": "",
                        "fullWidth": true,
                        "repeat": false,
                        "center": true,
                        "cover": false
                    },
                    "contentWidth": "500px",
                    "fontFamily": {
                        "label": "Arial",
                        "value": "arial,helvetica,sans-serif"
                    },
                    "linkStyle": {
                        "body": true,
                        "linkColor": "#0000ee",
                        "linkHoverColor": "#0000ee",
                        "linkUnderline": true,
                        "linkHoverUnderline": true
                    },
                    "_meta": {
                        "htmlID": "u_body",
                        "htmlClassNames": "u_body"
                    }
                }
            },
            "schemaVersion": 5
          }
        },
        {
          title: 'NymbleUp Welcome Promo',
          email_title: "NymbleUp Coffee -Your First One On Us!",
          content: {
            "counters": {
              "u_column": 1,
              "u_row": 1,
              "u_content_image": 2
            },
            "body": {
                "rows": [{
                    "cells": [1],
                    "columns": [{
                        "contents": [{
                            "type": "image",
                            "values": {
                                "containerPadding": "10px",
                                "_meta": {
                                    "htmlID": "u_content_image_2",
                                    "htmlClassNames": "u_content_image"
                                },
                                "selectable": true,
                                "draggable": true,
                                "duplicatable": true,
                                "deletable": true,
                                "src": {
                                    "url": "https://unroll-images-production.s3.amazonaws.com/projects/5523/1597038736354-We%20all%20know%20the%20secret%20to%20greatness%20comes%20in%20a%20cup.jpg",
                                    "width": 1587,
                                    "height": 2245
                                },
                                "textAlign": "center",
                                "altText": "Image",
                                "action": {
                                    "name": "web",
                                    "values": {
                                        "href": "",
                                        "target": "_blank"
                                    }
                                },
                                "hideDesktop": false,
                                "hideMobile": false
                            }
                        }],
                        "values": {
                            "border": {},
                            "padding": "0px",
                            "backgroundColor": "",
                            "_meta": {
                                "htmlID": "u_column_1",
                                "htmlClassNames": "u_column"
                            }
                        }
                    }],
                    "values": {
                        "columns": false,
                        "backgroundColor": "",
                        "columnsBackgroundColor": "",
                        "backgroundImage": {
                            "url": "",
                            "fullWidth": true,
                            "repeat": false,
                            "center": true,
                            "cover": false
                        },
                        "padding": "0px",
                        "hideDesktop": false,
                        "hideMobile": false,
                        "noStackMobile": false,
                        "_meta": {
                            "htmlID": "u_row_1",
                            "htmlClassNames": "u_row"
                        },
                        "selectable": true,
                        "draggable": true,
                        "duplicatable": true,
                        "deletable": true
                    }
                }],
                "values": {
                    "backgroundColor": "#e7e7e7",
                    "backgroundImage": {
                        "url": "",
                        "fullWidth": true,
                        "repeat": false,
                        "center": true,
                        "cover": false
                    },
                    "contentWidth": "500px",
                    "fontFamily": {
                        "label": "Arial",
                        "value": "arial,helvetica,sans-serif"
                    },
                    "linkStyle": {
                        "body": true,
                        "linkColor": "#0000ee",
                        "linkHoverColor": "#0000ee",
                        "linkUnderline": true,
                        "linkHoverUnderline": true
                    },
                    "_meta": {
                        "htmlID": "u_body",
                        "htmlClassNames": "u_body"
                    }
                }
            },
            "schemaVersion": 5
          }
        }
      ],
      from_date: "",
      to_date: "",
      start_time: "",
      end_time: "",
      email_template: '',
      email_title: '',
      sms_template: '',
      select_offer: 'Buy 1 Get 1',
      offer_list: [
        {
          title: 'Buy 1 Get 1',
          x_value: 1,
          y_value: 1
        },
        {
          title: 'Buy 2 Get 1',
          x_value: 2,
          y_value: 1
        },
        {
          title: 'Buy 2 Get 2',
          x_value: 2,
          y_value: 2
        }
      ],
      upload_type: 'CSV',
      form_action: 'SELECT_PROMOTION_TYPE',
      active_communication: 'EMAIL',
      active_sales_channel: 'DINE_IN',
      schedule_type: 'Schedule now',
      schedule_date: '',
      schedule_time: '',
      promotion_id: '',
      campaign_id: '',
      target_email_id_list: [],
      target_mobile_no_list: [],
      selected_file: ''
    };
  },

  watch: {
    upload_type(newValue, oldValue){
      // reset input filed on upload type raiod btn change
      this.selected_file = '';
      this.email_id_input_list = [
        {
          email_id: ''
        },
        {
          email_id: ''
        },
        {
          email_id: ''
        }
      ];

      this.mobile_no_input_list = [
        {
          mobile_no: ''
        },
        {
          mobile_no: ''
        },
        {
          mobile_no: ''
        }
      ];

      this.target_email_id_list = [];
      this.target_mobile_no_list = [];
    },

    schedule_type(newValue, oldValue){
      if(newValue == 'Schedule later'){
        this.schedule_date = '';
        this.schedule_time = '';
      }
    },

    frequency(newValue, oldValue){
      // if(newValue == 'limited'){
        this.discountable_days = [];
      // }
    }
  },

  created() {
    console.log(this.storeId);
    if(this.storeId) {
      this.active_promotion = 'NEAR EXPIRY';
      this.selected_promotion_id = '08848a13-e27c-4de9-9096-9cfd9951ca9b';
      this.dialogVisible = true;
      this.store = this.storeId;
      this.getProductListByStoreIdNetWorkCallBack(this.storeId);
    }
    // this.getAllPromotions();
    this.getStoreList();
  },

  mounted() {
    EventBus.$on("expiryDataToCampaing", this.expiryDataToCampaing)
    // console.log('this.$route.query', this.$route.query.promo_type);
    if(this.$route.query.store_id && this.$route.query.promo_type){

      this.store = this.$route.query.store_id;
      this.product_list = this.promotion_product_list;

      this.getProductListByStoreIdNetWorkCallBack(this.$route.query.store_id);

      //filtered promotion from promtion type getting from dashboard page
      let promotion = this.promo_type_list.filter((promo)=>{
        return promo.id == this.$route.query.promo_type;
      });

      console.log(promotion, this.promo_type_list);

      this.active_promotion = 'DISCOUNT';
      this.selected_promotion_id = '36b0c737-293d-476e-80c3-76eab7c01cb3';

      if(promotion.length){
        //assigned filtered promtion as a active promotion
        this.active_promotion = promotion[0].title;
        this.selected_promotion_id = promotion[0].id;
      }
      this.openCreateCampaignDialog();
    }
  },

  methods: {
    ...mapActions("CommonStore", ["getCompanyData"]),
    expiryDataToCampaing(data) {
      console.log("data", data);
    },
    addOneMoreComboInComboList(){
      let combo_obj = {
        product_list: [],
        select_item_list : [
          {
            item_id: '',
            selected_items: {},
            // price: '',
            discount: '',
            discounted_price: ''
          }
        ],
        combo_name: '',
        combo_total: '',
        combo_price: '',
        avg_discount: ''
      }

      this.combo_list.push(combo_obj);
    },

    addMoreItemsInXYList(xy_index){
      //created new object and pushed in next index to this.productXY_list
      let xy_boj = {
        x_product_list: [],
        y_product_list: [],
        select_x_item_list: [],
        select_y_item_list: [],
      }

      this.productXY_list.splice(xy_index+1, 0, xy_boj);

      let offer_obj = this.offer_list.filter(offer =>{
        return offer.title == this.select_offer
      })

      if(offer_obj.length){
        for(var i=0; i<offer_obj[0].x_value; i++){
          let obj = {};
          obj.product_type = 'Buy';
          obj.item_id = '';
          obj.selected_items = {};

          this.productXY_list[xy_index+1].select_x_item_list.push(obj);
        }

        for(var i=0; i<offer_obj[0].y_value; i++){
          let obj = {};
          obj.product_type = 'Get';
          obj.item_id = '';
          obj.selected_items = {};

          this.productXY_list[xy_index+1].select_y_item_list.push(obj);
        }
      }
    },

    addProductInItemList(item, combo_index, item_index){
      //checked that is product is selected in dropdown for combo
      if(Object.keys(item).length){
        this.combo_list[combo_index].product_list.push(item);
        this.combo_list[combo_index].select_item_list.splice(item_index, 1);   //cleared array after adding item in to list

        this.getTotalOfAddedComboProducts(combo_index);
      }
    },

    addItemInSelectItemList(combo_index){
      let obj = {};
      obj.item_id = '';
      obj.selected_items = {};
      this.combo_list[combo_index].select_item_list.push(obj); //pushded blank obj in selected item list to show product dropdown in combo table
    },

    // api to get store list
		getStoreList() {
			LabourPalnningService.getAllStoreData().then(response => {
				if (response.status == 200) {
					let all_store_list = JSON.parse(response.data);
					this.store_list = all_store_list.filter(e => {
						if (e.type == "store") {
							return e;
						}
					});
          this.store_list.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)); // sort a-z store list
				} else {
					this.store_list = [];
				}
      });
    },

    // get all promotions api
		getAllPromotions() {
			CampaignsService.getAllPromotions().then(response => {
				if (response.status == 200) {
          // console.log('getAllPromotions', JSON.parse(response));
				} else {
				}
      });
    },

    //api to get get product list by store id
    getProductListByStoreIdNetWorkCallBack(store_id){
      let obj = {
        outlets: [store_id]
      };
      if(this.active_promotion == 'NEAR EXPIRY') {
        let params = {
          filters:{ outlets:[store_id]},
          from_date: moment().format("YYYY-MM-DD"),
          to_date:moment().format("YYYY-MM-DD"),
          quick_report:"wfr"
        }
        ExpiryService.getAllExpiry(params).then(res =>{
          if(res.status == 200){
            let resArr = [];
            let data = JSON.parse(res.data);
            data.filter(function(item){
              let i = resArr.findIndex(x => x.article_id == item.article_id);
              if(i <= -1){
                resArr.push(item);
              }
              return null;
            });
            this.product_list = resArr;
            if(this.storeId) {
              let obj = localStorage.getItem("checklist");
              let checklist = JSON.parse(obj).checklist;
              for(let i = 0; i < checklist.length; i++) {
                this.getProductDetailsByProductIDNetworkCallBack(checklist[i]);
              }
              this.product = checklist[checklist.length -1];
            }

          }else{
            this.product_list = [];
          }
        })
        .catch(function(err){
          console.log(err);
          this.product_list = [];
        }.bind(this))
      } else {
        CampaignsService.getProductListByStore(obj).then(res =>{
          if(res.status == 200){
            this.product_list = JSON.parse(res.data);
          }else{
            this.product_list = [];
          }
        })
        .catch(function(err){
          console.log(err);
          this.product_list = [];
        }.bind(this))

      }
    },

    //api to get get product list by store id
    //combo_index, item_index gets only on selection of combo promotion type
    getProductDetailsByProductIDNetworkCallBack(product_id, combo_index, item_index){
      CampaignsService.getProductDetailsByProductId(product_id).then(res =>{
        if(res.status == 200){
          // console.log("getProductDetailsByProductIDNetworkCallBack", JSON.parse(res.data));
          let product = JSON.parse(res.data);

          this.$set(product, 'discount', '');
          this.$set(product, 'discounted_price', '');
          this.$set(product, 'price', Number(product.price));

          // if active promotion is DISCOUNT then push product in item list
          //for other other promotion type we are using separate array for product list e.g. combo list
          if(this.active_promotion == "DISCOUNT" || this.active_promotion == "NEAR EXPIRY"){
            this.item_list.push(product);
          }else if(this.active_promotion == "COMBO"){
            this.combo_list[combo_index].select_item_list[item_index].selected_items = product;
          }
        }
      })
      .catch(function(err){
        console.log(err);
      }.bind(this))
    },

    getProductDetailsByProductIDForXYProductTypeNetworkCallBack(product_id, xy_index, item_index, product_type){
      CampaignsService.getProductDetailsByProductId(product_id).then(res =>{
        if(res.status == 200){
          // console.log("getProductDetailsByProductIDNetworkCallBack", JSON.parse(res.data));
          let product = JSON.parse(res.data);

          this.$set(product, 'discount', '');
          this.$set(product, 'discounted_price', '');
          this.$set(product, 'price', Number(product.price));

          if(product_type == 'X_product'){
            product.product_type = 'Buy';   //assinged product type;
            this.productXY_list[xy_index].select_x_item_list[item_index].selected_items = product;
            console.log(this.productXY_list[xy_index].select_x_item_list[item_index].selected_items);
          }else if(product_type == 'Y_product'){
            product.product_type = 'Get'; //assinged product type;
            this.productXY_list[xy_index].select_y_item_list[item_index].selected_items = product;
          }

        }
      })
      .catch(function(err){
        console.log(err);
      }.bind(this))
    },

    savePromotionNetWorkCallBack(){
      this.$validator.validateAll().then(result => {

        if(result){
          if(this.frequency == 'recurring' && this.days == '' && !this.discountable_days.length){
            this.$notify.error({
              title: "Error",
              message: 'Select days'
            });
          }else{
            let obj = {};
            obj.company = this.companyData.id;
            obj.name = this.campaign_title;
            obj.promotion_type = this.selected_promotion_id;
            obj.available_regions = [];
            obj.available_subregions = [];
            obj.available_outlets = [{ id: this.store}];
            obj.details = this.active_promotion == 'DISCOUNT' || this.active_promotion == 'NEAR EXPIRY' ? JSON.stringify(this.item_list) : this.active_promotion == 'COMBO' ? JSON.stringify(this.combo_list) : this.active_promotion == 'BUY X & GET Y' ? JSON.stringify(this.productXY_list) : '' ;
            obj.status = 'a';

            CampaignsService.savePromotion(obj).then(res =>{
              if(res.status == 200){
                console.log("savePromotionNetWorkCallBack", JSON.parse(res.data));
                let response = JSON.parse(res.data);
                this.promotion_id = response.id;

                this.saveCampaignNetworkCallBack();
              }
            })
            .catch(function(err){
              console.log(err);
            }.bind(this))
          }
        }
      })
    },

    saveCampaignNetworkCallBack(){

      let obj = {};
      obj.company = this.companyData.id;
      obj.promotion = this.promotion_id;
      obj.start_date = moment(this.from_date).format('YYYY-MM-DD');
      obj.end_date = moment(this.to_date).format('YYYY-MM-DD');
      obj.start_time = this.start_time;
      obj.end_time = this.end_time;
      obj.slug = 'slug';
      obj.is_recurring = this.frequency == 'recurring' ? true : false;
      obj.recurring_day = (this.frequency == 'recurring' && this.days == 'all') ? 7 : (this.frequency == 'recurring' && this.days != 'all') ? (this.discountable_days).toString() : '',
      obj.recurring_daypart = "",
      obj.regions = [];
      obj.subregions = [];
      obj.outlets = [{ id: this.store}];
      obj.status = 'a';

      CampaignsService.saveCampaign(obj).then(res =>{
        if(res.status == 200){
          console.log("saveCampaignNetworkCallBack", JSON.parse(res.data));
          let response = JSON.parse(res.data);
          this.campaign_id = response.id;

          this.$notify.success({
            title: "Success",
            message: 'Campaign successfully saved'
          });

          this.selectNextStepOfCampaign('SELECT_COMMUNICATION_TYPE');
        }
      })
      .catch(function(err){
        console.log(err);
      }.bind(this))
    },

    saveCommunicationNetworkCallBack(){
      this.$validator.validateAll().then(result => {
        // console.log('result...', result);
        if(result){

          if(this.upload_type == 'MANUALLY'){

            if(this.active_communication == 'EMAIL'){
              if(!this.target_email_id_list.length){
                this.$notify.error({
                  title: "Error",
                  message: 'Select target Email Ids'
                });
                return;
              }
            }else if(this.active_communication == 'SMS'){
              if(!this.target_mobile_no_list.length){
                this.$notify.error({
                  title: "Error",
                  message: 'Select target Mobile Nos'
                });
                return;
              }
            }

            let obj = {};
            obj.communication_type = this.active_communication == 'EMAIL' ? 'email' : 'sms';
            obj.campaign = this.campaign_id;
            obj.content = this.active_communication == 'EMAIL' ? this.email_content.html : this.sms_content;
            obj.content_title = this.active_communication == 'EMAIL' ? this.email_title : '';
            obj.content_metadata = 'the email component info if required';
            obj.target_list = this.active_communication == 'EMAIL' ? (this.target_email_id_list).toString() : (this.target_mobile_no_list).toString();
            obj.scheduled_time = (this.schedule_date && this.schedule_time) ? `${moment(this.schedule_date).format('YYYY-MM-DD')} ${this.schedule_time}` : `${moment().format('YYYY-MM-DD')} ${moment().format('HH:mm')}`;
            obj.status = 'a';

            CampaignsService.saveCommunication(obj).then(res =>{
              if(res.status == 200){
                let response = JSON.parse(res.data);
                this.campaign_id = response.campaign;

                this.selectNextStepOfCampaign('SALES_CHANNEL_TYPE');

                this.$notify.success({
                  title: "Success",
                  message: 'Communication successfully saved'
                });

              }
            })
            .catch(function(err){
              console.log(err);
            }.bind(this))

          }else if(this.upload_type == 'CSV'){

            if(this.selected_file){   //checked is file selected
              let obj = {};
              obj.communication_type = this.active_communication == 'EMAIL' ? 'email' : 'sms';
              obj.campaign = this.campaign_id;
              obj.content = this.active_communication == 'EMAIL' ? this.email_content.html : this.sms_content;
              obj.content_title = this.active_communication == 'EMAIL' ? this.email_title : '';
              obj.content_metadata = 'the email component info if required';
              obj.target_list = '';
              obj.scheduled_time = (this.schedule_date && this.schedule_time) ? `${moment(this.schedule_date).format('YYYY-MM-DD')} ${this.schedule_time}` : `${moment().format('YYYY-MM-DD')} ${moment().format('HH:mm')}`;
              obj.status = 'a';

              CampaignsService.saveCommunication(obj).then(res =>{
                if(res.status == 200){
                  console.log("saveCampaignNetworkCallBack", JSON.parse(res.data));
                  let response = JSON.parse(res.data);
                  this.campaign_id = response.campaign;
                  let communication_id = response.id;

                  let formData = new FormData();
                  formData.append('communication_id', communication_id);
                  formData.append('csv_file', this.selected_file);

                  CampaignsService.saveCommunicationCSV(formData).then((response) =>{
                    console.log('saveCommunicationCSV', response)
                    if(response.status){
                      this.selectNextStepOfCampaign('SALES_CHANNEL_TYPE');

                      this.$notify.success({
                        title: "Success",
                        message: 'Communication successfully saved'
                      });
                    }
                  })
                }
              })
              .catch(function(err){
                console.log(err);
              }.bind(this))
            }else{
              this.$notify.error({
                title: "Error",
                message: 'Please select csv'
              });
            }
          }
        }

      })
    },

    sendCommunicationForCampaign(){
      let obj = {};
      obj.id = this.campaign_id;

      CampaignsService.sendCommunicationForCampaign(obj).then(res =>{
        if(res.status == 200){
          console.log("sendCommunicationForCampaign", JSON.parse(res.data));
          this.$notify.success({
            title: "Success",
            message: 'Communication sent for campaign'
          });

          this.selectNextStepOfCampaign('SUCCESS');
        }
      })
      .catch(function(err){
        console.log(err);
      }.bind(this))
    },

    editorLoaded(design) {
      this.$refs.emailEditor.editor.loadDesign(design ? design : undefined);
    },

    saveDesign() {
      this.$refs.emailEditor.editor.saveDesign(
        (design) => {
          console.log('saveDesign', design);
        }
      )
    },

    exportHtml() {
      this.$refs.emailEditor.editor.exportHtml(
        (data) => {
          console.log('exportHtml', data);
          this.email_content = data;

          this.saveCommunicationNetworkCallBack();
        }
      )
    },

    // load email template
    selecteEmailTemplate(index){
      this.email_title = this.email_template_list[index].email_title;
      this.editorLoaded(this.email_template_list[index].content);
    },

    selectSMSTemplate(template){
      this.sms_content = template;
    },

    selectNextStepOfCampaign(step){
      if(step == 'SELECT_COMMUNICATION_TYPE'){
        this.form_action = step;
        this.campaign_progress = 1;
      }else if(step == 'SELECT_PROMOTION_TYPE'){
        this.form_action = step;
        this.campaign_progress = 0;
      }else if(step == 'SALES_CHANNEL_TYPE'){
        this.campaign_progress = 2;
        this.form_action = step;
      }else if(step = "SUCCESS"){
        this.campaign_progress = 3;
        this.form_action = step;
      }
      this.dialogVisible = false;
    },

    goToSelectedCommunicationType(){
      if(this.active_communication == 'EMAIL'){
        this.form_action = 'EMAIL_COMMUNICATION';
      }else{
        this.form_action = 'SMS_COMMUNICATION';
      }

      this.upload_type = 'CSV';
      this.schedule_type = 'Schedule now';
      this.schedule_date = '';
      this.schedule_time = '';
      // reset input filed on communication type change
      this.selected_file = '';
      this.email_id_input_list = [
        {
          email_id: ''
        },
        {
          email_id: ''
        },
        {
          email_id: ''
        }
      ];

      this.mobile_no_input_list = [
        {
          mobile_no: ''
        },
        {
          mobile_no: ''
        },
        {
          mobile_no: ''
        }
      ];

      this.target_email_id_list = [];
      this.target_mobile_no_list = [];
    },

    //returns total of product added for combo
    getTotalOfAddedComboProducts(combo_index){
      if(this.combo_list[combo_index].product_list.length){
        let total = _.sumBy(this.combo_list[combo_index].product_list, 'price');

        this.combo_list[combo_index].combo_total = total;

        this.getAVGOfTotalDiscountAddedComboProducts(combo_index);
        // return total;
      }else{
        this.combo_list[combo_index].combo_total = '';
        this.combo_list[combo_index].avg_discount = '';
        this.combo_list[combo_index].combo_price = '';
      }
    },

    //returns total avg discount of product added for combo
    getAVGOfTotalDiscountAddedComboProducts(combo_index){
      if(this.combo_list[combo_index].product_list.length){

        let temp = [];
        // to ignore blanked discount value
        //if discount is not applicable then...retirieved discount and pushed in temp array and then calculated mean of that array values
        for(var i=0; i <this.combo_list[combo_index].product_list.length; i++){
          if(this.combo_list[combo_index].product_list[i].discount){
            temp.push(this.combo_list[combo_index].product_list[i].discount);
            console.log('discount', this.combo_list[combo_index].product_list[i])
          }
        }

        let avg = _.mean(temp.length ? temp : [0]);

        this.combo_list[combo_index].avg_discount = avg;

        this.getDiscountedTotalCOMBOPrice(combo_index);
        // return avg;
      }else{
        this.combo_list[combo_index].avg_discount = '';
      }
    },

    getDiscountedTotalCOMBOPrice(combo_index){
      if(this.combo_list[combo_index].product_list.length){
        let combo_price = this.calculateDiscountedPrice(this.combo_list[combo_index].combo_total, this.combo_list[combo_index].avg_discount);

        this.combo_list[combo_index].combo_price = combo_price;

      }else{
        this.combo_list[combo_index].combo_price = '';
      }
    },

    // function called when applicable to all is checked
    applyDiscountToItems(discount){
      this.item_list.forEach(element => {
        if(this.applicable_to_all && discount){
          element.discount = '';
          element.discounted_price = this.calculateDiscountedPrice(element.price, discount);
        }else{
          element.discount = '';
          element.discounted_price = '';
        }
      });
    },

    // function called when discount dropdown changed from item list table
    applyDiscountFromItemTable(index, discount){
      if(discount){
        this.item_list[index].discounted_price = this.calculateDiscountedPrice(this.item_list[index].price, discount);
      }else if(this.applicable_to_all && this.discount_percentage){
        this.item_list[index].discounted_price = this.calculateDiscountedPrice(this.item_list[index].price, discount);
      }else{
        this.item_list[index].discounted_price = '';
      }
    },

    // function called when discount dropdown changed from combo table
    applyDiscountFromCOMBOTable(discount, item_index, combo_index){
      if(discount && this.combo_list[combo_index].select_item_list[item_index].item_id){
        this.combo_list[combo_index].select_item_list[item_index].selected_items.discount = discount;

        this.combo_list[combo_index].select_item_list[item_index].selected_items.discounted_price = this.calculateDiscountedPrice(this.combo_list[combo_index].select_item_list[item_index].selected_items.price, discount);
      }else{
        this.combo_list[combo_index].select_item_list[item_index].selected_items.discounted_price = '';
      }
    },

    // function called when discount dropdown changed from buy x and get y table
    applyDiscountFromBuyXYable(discount, item_index, xy_index, product_type){
      console.log('applyDiscountFromBuyXYable', discount, this.productXY_list[xy_index].select_y_item_list[item_index]);
      if(discount && this.productXY_list[xy_index].select_y_item_list[item_index].item_id){
        this.productXY_list[xy_index].select_y_item_list[item_index].selected_items.discount = discount;

        this.productXY_list[xy_index].select_y_item_list[item_index].selected_items.discounted_price = this.calculateDiscountedPrice(this.productXY_list[xy_index].select_y_item_list[item_index].selected_items.price, discount);
      }else{
        this.productXY_list[xy_index].select_y_item_list[item_index].selected_items.discounted_price = '';
      }
    },

    // function to call discount
    calculateDiscountedPrice(price, discount){
      let pr = price;
      let dis = discount/100
      let total = price - ( price * dis);

      return total.toFixed();
    },

    //function to remove item from list
    removeItemFromList(index){
      this.item_list.splice(index, 1);
    },

    //function to remove item from combo list
    removeItemFromComboList(combo_index, product_index){
      this.combo_list[combo_index].product_list.splice(product_index, 1);
      this.getTotalOfAddedComboProducts(combo_index);
    },


    addSelectedProductInXItemList(item, xy_index, item_index){
      console.log('addSelectedProductInXItemList', item);
      //checked that is product is selected in dropdown
      if(Object.keys(item).length){
        this.productXY_list[xy_index].x_product_list.push(item);
        this.productXY_list[xy_index].select_x_item_list.splice(item_index, 1);   //cleared array after adding item in to list
      }
    },

    addSelectedProductInYItemList(item, xy_index, item_index){
      console.log('addSelectedProductInYItemList', item);
      //checked that is product is selected in dropdown
      if(Object.keys(item).length){
        this.productXY_list[xy_index].y_product_list.push(item);
        this.productXY_list[xy_index].select_y_item_list.splice(item_index, 1);   //cleared array after adding item in to list
      }
    },

    //function to remove item from buy x and get y list
    removeItemFromXProductList(xy_index, product_index){

      this.productXY_list[xy_index].x_product_list.splice(product_index, 1);   //removed from product array and pushed in select product  array

      let obj = {};
      obj.product_type = 'Buy';
      obj.item_id = '';
      obj.selected_items = {};
      this.productXY_list[xy_index].select_x_item_list.push(obj);
    },

    //function to remove item from buy x and get y list
    removeItemFromYProductList(xy_index, product_index){
      this.productXY_list[xy_index].y_product_list.splice(product_index, 1); //removed from product array and pushed in select product  array

      let obj = {};
      obj.product_type = 'Get';
      obj.item_id = '';
      obj.selected_items = {};
      this.productXY_list[xy_index].select_y_item_list.push(obj);
    },

    changeOfferType(offer_type){
      this.productXY_list = [
        {
          x_product_list: [],
          y_product_list: [],
          select_x_item_list: [],
          select_y_item_list: [],
        }
      ];

      let offer_obj = this.offer_list.filter(offer =>{
        return offer.title == offer_type
      })

      if(offer_obj.length){
        for(var i=0; i<offer_obj[0].x_value; i++){
          let obj = {};
          obj.product_type = 'Buy';
          obj.item_id = '';
          obj.selected_items = {};

          this.productXY_list[0].select_x_item_list.push(obj);
        }

        for(var i=0; i<offer_obj[0].y_value; i++){
          let obj = {};
          obj.product_type = 'Get';
          obj.item_id = '';
          obj.selected_items = {};

          this.productXY_list[0].select_y_item_list.push(obj);
        }
      }

      // console.log('this.productXY_list', this.productXY_list);
    },

    // adds one input field in list
    addMoreEmailIdFields(){
      let obj = { email_id : ''};
      this.email_id_input_list.push(obj);
    },

    addMoreMobileNoFields(){
      let obj = { mobile_no : ''};
      this.mobile_no_input_list.push(obj);
    },

    setActiveSaleChannle(lable){
      if(lable == 'DINE_IN'){
        this.active_sales_channel = lable;
      }else if(lable == 'TAKE_AWAY'){
        this.active_sales_channel = lable;
      }else if(lable == 'SWIGGY'){
        this.active_sales_channel = lable;
      }else if(lable == 'ZOMATO'){
        this.active_sales_channel = lable;
      }
    },

    setActiveCommunication(label){
      if(label == 'EMAIL'){
        this.active_communication = label;
      }else{
        this.active_communication = label;
      }
    },

    getCsvFile(){
      let file = this.$refs['file'].files[0];
      var type = file.type.split('/').pop().toLowerCase();
      if (type == "csv") {
        this.selected_file = this.$refs['file'].files[0];
      }else{
        this.$notify.error({
          title: "Error",
          message: 'Please select valid csv file only'
        });
      }
    },

    // function to clear all form fields when dialog opens
    clearDiscountFrom(){
      this.store = '';
      this.product = '';
      this.campaign_title = '';
      this.discount_percentage = '';
      this.days = 'all';
      this.upload_type = 'CSV';
      this.discountable_days = [];
      this.frequency = 'recurring';
      this.from_date = '';
      this.to_date = '';
      this.start_time = '';
      this.end_time = '';
      this.email_template = '';
      this.email_title = '';
      this.schedule_type = 'Schedule now';
      this.schedule_date = '';
      this.schedule_time = '';
      this.select_offer = 'Buy 1 Get 1';
      this.active_communication = 'EMAIL';

      this.selected_file = '';

      this.item_list = [];

      this.combo_list = [
        {
          product_list: [],
          select_item_list : [
            {
              item_id: '',
              selected_items: {},
              // price: '',
              discount: '',
              discounted_price: ''
            },
            {
              item_id: '',
              selected_items: {},
              // price: '',
              discount: '',
              discounted_price: ''
            }
          ],

          combo_name: '',
          combo_total: '',
          combo_price: '',
          avg_discount: ''
        }
      ];

      this.productXY_list = [
        {
          x_product_list: [],
          y_product_list: [],
          select_x_item_list: [],
          select_y_item_list: [],
        }
      ];

      this.email_id_input_list = [
        {
          email_id: ''
        },
        {
          email_id: ''
        },
        {
          email_id: ''
        }
      ];

      this.mobile_no_input_list = [
        {
          mobile_no: ''
        },
        {
          mobile_no: ''
        },
        {
          mobile_no: ''
        }
      ];

      this.target_email_id_list = [];
      this.target_mobile_no_list = [];
    },

    openCreateCampaignDialog(form_status){
      this.dialogVisible = true;
      if(form_status == 'CLEAR_DISCOUNT_FORM'){
        this.clearDiscountFrom();
      }

      if(this.active_promotion == 'BUY X & GET Y'){
        // initially called function to fill default xy product list
        this.changeOfferType('Buy 1 Get 1');
      }
    },

    closeCreateCampaignDialog(){
      this.dialogVisible = false;
    },

    selectPromotion(promo){
      // if(promo.title == 'DISCOUNT' || promo.title == 'COMBO' || promo.title == 'BUY X & GET Y'){
        this.active_promotion = promo.title;
        this.selected_promotion_id = promo.id;
      // }
    },

    cancelSelectedPromotion(){
      this.active_promotion = '';
    }
  },

  computed: {
    ...mapState("CommonStore", ["companyData", "promotion_product_list"]),
  },
};
</script>

<style lang="scss" scoped>
.CreateCampaign .offer {
  margin: 10px 0 10px 0px;
}

.CreateCampaign .offers {
  margin: 0px 0 0px 20px;
}

.CreateCampaign button {
  text-align: center;
	border-radius: 2px;
	cursor: pointer;
	letter-spacing: 0.02em;
	transition: all 0.2s ease;
  color: #fff;
  height: 40px;
	width: 100%;
  font-size: 10px;
  font-weight: bold;
  background-color: #2B2B2B6A;
}

.CreateCampaign .mini-button {
  text-align: center;
	border-radius: 2px;
	cursor: pointer;
	letter-spacing: 0.02em;
	transition: all 0.2s ease;
  color: #fff;
  height: 25px;
	width: 50px!important;
  line-height: 0;
  font-size: 10px;
  font-weight: bold;
  background-color: #0cf099;
  border-color: #0cf099;
}

.CreateCampaign .active-btn{
  border: 1px solid #e29d5a;
	background-color: #e29d5a;
}

.CreateCampaign .actio-btn-section{
  display: flex;
  justify-content: flex-end;
  button{
    width: 120px;
    height: 30px;
    border: 1px solid #e29d5a;
    background-color: #e29d5a;
  }
}

.CreateCampaign .body {
  min-height: calc(100vh - 1.5rem - 3rem - 32px);
  overflow-y: hidden;
  overflow-x: hidden;
}

.CreateCampaign .title {
  font-size: 16px;
  font-weight: bold;
  color: #e29d5a;
}
.CreateCampaign .divider label {
  line-height: 40px;
  font-size: 11px;
  font-weight: bold;
}
.CreateCampaign .campaignTable table {
  width: 100%;
  margin: 0 auto 10px;
  text-align: center
}

.CreateCampaign .campaignTable thead{
  background-color: #f2f2f2;
}

.CreateCampaign .campaignTable table th {
  padding: 12px;
  font-size: 10px;
  letter-spacing: 0px;
  color: #2B2B2B;
}
.CreateCampaign .campaignTable table td {
  padding: 10px;
  font-size: 12px;
  letter-spacing: 0px;
  color: #707070;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
.CreateCampaign .step-title{
  color: #e29d5a;
  font-weight: 600;
}
</style>

<style lang="scss">
.CreateCampaign .success-campaign-box{
  height: 350px;
  width: 400px;
  margin: 50px auto;
  text-align: center;
  .el-card__body{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.customClass {
  // position: absolute;
  // right: 0;
  min-height: 100vh;
  margin: 0 auto;
  .el-dialog__header {
	  display: none;
  }
  .el-dialog__body {
    padding: 1.5rem 3rem 0 3rem;
    color: unset;
    min-height: 100vh;
  }
}
.el-step__title{
  font-size: 11px;
  line-height: 15px;
  color: #000!important;
  margin: 10px auto;
}
.el-step__title.is-process{
  background-color: #f2f2f2;
  padding: 5px;
  max-width: 150px;
}
.el-step__icon{
  width: 30px;
  height: 30px;
}
.el-step__icon.is-text{
  font-size: 11px;
  background-color: #e29d5a;
  border-color: #e29d5a;
  color: #fff;
}
.el-step.is-horizontal .el-step__line{
  top: 14px;
}
.CreateCampaign .email-id-input {
  text-transform: lowercase!important;
}
.CreateCampaign .el-checkbox {
  margin-right: 8px;
}
.CreateCampaign .el-radio__label{
  font-weight: 200;
}
.CreateCampaign .quillWrapper .ql-snow.ql-toolbar{
  background-color: #f2f2f2;
}
.CreateCampaign iframe{
  width: 100%!important;
  height: 500px!important;
  min-width: unset!important;
}
.QbrbP .blockbuilder-branding{
  display: none!important;
}
</style>

